<div class="impressum">
  <div class="contact">
    <h2>Impressum</h2>
    <p></p>
    <p>
      Created and designed by:
    </p>
    <p></p>
    <p>ROOFTOP RADIO</p>
    <p>Justus Markert<br/>
      Augustastraße 33<br/>02826 Görlitz</p>
    <p>
      E-Mail: <a href="mailto:band@rooftopradio.de">band@rooftopradio.de</a><br/>
    </p>
    <p>Quelle: <a href="https://www.juraforum.de">Mehr dazu erfahren</a></p>
    <p>
    </p>
    <p>artwork by Franco Roschar (www.fiverr.com/roschar)</p>
    <p>photo by André Schulze (www.as-photos.de)</p>
  </div>
  <div>
    <span (click)="navigation.home()" style="cursor: pointer;font-family: Komikazoom, 'Komikazoom', sans-serif;color: #FFE693;font-size: x-large">
        <mat-icon class="back-icon">arrow_back_ios</mat-icon>
        ZURÜCK
      </span>
  </div>

</div>
